module.exports = __webpack_public_path__ + "img/DefaultFeedbackGood.53c5a828.png";